module.exports = __webpack_public_path__ + "static/octocat-0ba2aa20e2c2ce80e9a2db5b07198464.png";